import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Constants } from '../../../app.constants';
import { MerchantService } from '../../../services/merchant.service';
import { Customer } from '../../../models';

@Component({
  selector: 'app-test-notification-dialog',
  templateUrl: './test-notification-dialog.component.html',
  styleUrls: ['./test-notification-dialog.component.css'],
})
export class TestNotificationDialogComponent implements OnInit {
  form: FormGroup;
  customerFormControl: FormControl = new FormControl(null, [
    Validators.required,
  ]);

  customers: Customer[] = [];
  loading = false;
  sending = false;
  error = false;

  constructor(
    public matDialogRef: MatDialogRef<TestNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public constants: Constants,
    private merchantService: MerchantService,
  ) {
    this.form = new FormGroup({
      customer: this.customerFormControl,
    });
  }

  ngOnInit(): void {
    this.loadCustomers();
  }

  loadCustomers(): void {
    this.loading = true;
    this.merchantService
      .getCustomers('_id', 'desc', 5000, 0, '', {})
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.customers = res.docs;

            this.customers.forEach((el) => {
              if (typeof el.user !== 'string') {
                el.email = el.user?.email ?? el.email;
              }
            });
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  sendTest(): void {
    if (this.form.invalid) {
      this.constants.snack('Please select a customer');
      return;
    }

    this.sending = true;

    const payload = {
      message: this.data.message,
      from: this.data.from,
      recipient: this.customerFormControl.value?.user?._id,
    };

    this.merchantService
      .sendTestPushNotification(payload)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.constants.snack('Test notification sent successfully');
            this.matDialogRef.close(true);
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message, true);
        },
      })
      .add(() => (this.sending = false));
  }

  cancel(): void {
    this.matDialogRef.close();
  }
}
